import data from '../block.json';
import "./frontend.scss"

const initializeBlock = (block) => {

    let blockInstance = block;
    let mediaQuery = window.matchMedia('(max-width: 1023px)');
   /* const mediaQueryDesktop = window.matchMedia('(max-width: 1024px)');*/
    if (window.acf) {

        blockInstance = block[0];
    }



    console.log("Selected Category CTA");





}

const init = () => {
    const {name} = data;

    if (window.acf) {
        window.acf.addAction(`render_block_preview/type=${name}`, initializeBlock);

    } else {
        let blocksOfTypes = document.querySelectorAll('.selected-category-widget');
        blocksOfTypes.forEach(e => {
            initializeBlock(e);
        });
    }

};

if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    init();
} else {
    document.addEventListener('DOMContentLoaded', init);
}


